"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalProgressBarChart = void 0;
const react_1 = __importStar(require("react"));
const VerticalProgressBar_1 = require("./VerticalProgressBar");
const types_1 = require("../../gameplay/types");
const VerticalProgressBarChart = (props) => {
    // const [maxResponses, setMaxResponses] = useState(0);
    const [totalResponses, setTotalResponses] = (0, react_1.useState)(0);
    // todo: decide if we want max responses or total responses
    // useEffect(() => {
    //   let max = 0;
    //   props.choiceStats.forEach((question, idx) => {
    //     if (question.playerCount > max) {
    //       max = question.playerCount;
    //     }
    //   });
    //   setMaxResponses(max);
    // }, [props.choiceStats]);
    (0, react_1.useEffect)(() => {
        let sum = 0;
        props.choiceStats.forEach(question => {
            sum += question.playerCount;
        });
        setTotalResponses(sum);
    }, [props.choiceStats]);
    return (react_1.default.createElement("div", { style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'end',
            gap: '0.5rem',
        } }, props.choiceStats.map(data => (react_1.default.createElement(VerticalProgressBar_1.VerticalProgressBar, { progress: (data.playerCount / totalResponses) * 100, numResponses: data.playerCount, isCorrect: data.choice === props.correctAnswer, blurred: data.choice !== props.correctAnswer &&
            props.gameplayControl !== types_1.GameplayControl.PresentQuestion, title: data.choice, imgSrc: data.imageUrl, gameplayStyle: props.gameplayStyle, className: props.className })))));
};
exports.VerticalProgressBarChart = VerticalProgressBarChart;
